import { Component, Inject } from '@angular/core';
import { ModalBaseComponent } from 'app/core/modal';
import { REVIEW_CLASSES } from '../../constants';
import { FormControl, FormGroup } from '@angular/forms';
import { isEmpty } from 'lodash';
import { MaterialModalBaseComponent } from 'app/core/modal/material-modal-base.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ReviewState {
  carrierScore: number;
  productScore: number;
  packagingScore: number;
}

interface TrackingPageFeedbackModalResult extends ReviewState {
  comment: string;
}

@Component({
  selector: 'app-tracking-page-feedback-modal',
  templateUrl: './tracking-page-feedback-modal.component.html',
  styleUrls: ['./tracking-page-feedback-modal.component.scss']
})
export class TrackingPageFeedbackModalComponent extends MaterialModalBaseComponent<
  TrackingPageFeedbackModalResult
> {
  public number;
  public data;

  public reviewState: ReviewState = {
    carrierScore: null,
    productScore: null,
    packagingScore: null
  };

  comment: FormControl;
  formGroup: FormGroup;
  disabled: boolean;

  public readonly reviewClasses = REVIEW_CLASSES;

  constructor(@Inject(MAT_DIALOG_DATA) public params: any) {
    super(params);
    this.number = params.number;
    this.data = params.data;
  }

  ngOnInit() {
    this.comment = new FormControl(
      (this.data && this.data.comment) || '',
      (control: FormControl) => {
        return !control.value ||
          !control.value
            .toString()
            .replace(/[()_-]/g, '')
            .trim()
          ? { required: true }
          : null;
      }
    );
    this.formGroup = new FormGroup({
      comment: this.comment
    });

    if (this.data && !isEmpty(this.data)) {
      this.reviewState = {
        carrierScore: parseFloat(this.data.carrierScore) || 0,
        productScore: parseFloat(this.data.productScore) || 0,
        packagingScore: parseFloat(this.data.packagingScore) || 0
      };
      this.comment.disable();
      this.disabled = true;
    }
  }

  updateRating(key: string, value: number): void {
    if (!this.disabled) {
      this.reviewState = { ...this.reviewState, [key]: value };
    }
  }

  getCeilReview(): string {
    const result =
      Math.floor(
        (Object.values(this.reviewState).reduce((acc, curr) => acc + curr) /
          3) *
          10
      ) / 10;
    return result === 0 ? '0.0' : result.toString();
  }

  getClass(): string {
    const result = Math.floor(parseFloat(this.getCeilReview()));
    return this.reviewClasses[result];
  }

  submitReview() {
    if (
      this.comment.valid &&
      this.reviewState.carrierScore &&
      this.reviewState.packagingScore &&
      this.reviewState.productScore
    ) {
      this.submit({ ...this.reviewState, comment: this.comment.value });
    }
  }
}
